export default __webpack_public_path__ + "static/backgroundNewsletter-77fec471a289ee8ebde8ca4545f7e8d0.jpg";